import ApiClient from '../ApiClient';

class WebChannel extends ApiClient {
  constructor() {
    super('channels', { accountScoped: true });
  }
}

export default new WebChannel();
